import React from 'react';

function Header() {
  return (
    <>
      <div class = "p-28">
      <h1 className='font-bold text-5xl text-center font-serif object-center'>
        UTD Clubs and Organizations
      </h1>
      </div>
    </>
  );
}

export default Header;
